define('presentation/settings/reports/facades/editReportFacade',[
    'externalDependencies/clientWebSocket',
    'presentation/common/dateTimeValue',
    'presentation/settings/reports/presentationObjects/reportPresentationObject'
], function() {
    const DateTimeValueConstructor = require('presentation/common/dateTimeValue');
    const ScheduledReportPresentationObjectConstructor = require('presentation/settings/reports/presentationObjects/reportPresentationObject');

    const clientWebSocket = require('externalDependencies/clientWebSocket');
    const _scheduledReportSocket = clientWebSocket.forApplication("scheduledReport");

    let _promiseFactory = null;

    const _buildScheduledReportPresentationObject = (scheduledReport) => {
        let scheduledReportPresentationObject = new ScheduledReportPresentationObjectConstructor();
        scheduledReportPresentationObject.scheduledReportId = scheduledReport.scheduledReportId;
        scheduledReportPresentationObject.subject = scheduledReport.subject;
        scheduledReportPresentationObject.message = scheduledReport.message;
        scheduledReportPresentationObject.sendToEmailAddresses = scheduledReport.sendToEmailAddresses;
        scheduledReportPresentationObject.deliveryFrequency(scheduledReport.deliveryFrequency.toString());
        scheduledReportPresentationObject.graphDataPointsBy(scheduledReport.graphDataPointsBy.toString());
        scheduledReportPresentationObject.deliveryFormat(scheduledReport.deliveryFormat.toString());
        scheduledReportPresentationObject.timeframe = scheduledReport.timeFrame;
        scheduledReportPresentationObject.involvingHostedNumbers = scheduledReport.involvingHostedNumbers;
        scheduledReportPresentationObject.involvingUsers = scheduledReport.involvingUsers;
        scheduledReportPresentationObject.involvingUserGroups = scheduledReport.involvingUserGroups;
        scheduledReportPresentationObject.createdDateTime = new DateTimeValueConstructor(scheduledReport.createdDateTime);
        scheduledReportPresentationObject.modifiedDateTime = new DateTimeValueConstructor(scheduledReport.updatedDateTime);
        return scheduledReportPresentationObject;
    };

    const _getScheduledReport = (scheduledReportId) => {
        return _promiseFactory.defer((promise) => {
            _scheduledReportSocket.send("getScheduledReport", { scheduledReportId }, (response) => {
                const scheduledReport = _buildScheduledReportPresentationObject(response);
                promise.resolve(scheduledReport);
            });
        });
    };

    const _updateScheduledReport = (scheduledReportId, subject, message, format, graphDataPointsBy, frequency, sendToEmailAddresses) => {
        return _promiseFactory.defer((promise) => {
            const scheduledReport = {
                scheduledReportId,
                subject,
                message,
                deliveryFormat: parseInt(format),
                graphDataPointsBy: parseInt(graphDataPointsBy),
                deliveryFrequency: parseInt(frequency),
                sendToEmailAddresses
            };
            _scheduledReportSocket.send("updateScheduledReport", scheduledReport, (response) => {
                promise.resolve(response);
            });
        });
    };

    const _init = (promiseFactory) => {
        _promiseFactory = promiseFactory;
    };

    const _dispose = () => {
        _scheduledReportSocket.disposeOfEvents();
    };

    return function() {
        const self = this;

        self.init = _init;
        self.dispose = _dispose;

        self.getScheduledReport = _getScheduledReport;
        self.updateScheduledReport = _updateScheduledReport;
    };
});

